var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "tipoMovimiento",
              attrs: {
                deleteButton: _vm.puede_anular,
                createButton: _vm.puede_crear,
                editButton: false,
                path: _vm.path,
                columns: [
                  {
                    display: "Código",
                    value: "codigo"
                  },
                  {
                    display: "Tipo",
                    value: "descripcion_tipo"
                  },
                  {
                    display: "Tipo de aplicación",
                    value: "descripcion_tipo_aplicacion"
                  },
                  {
                    display: "Descripción",
                    value: "descripcion"
                  },
                  {
                    display: "Creador",
                    value: "creador.nombre"
                  },
                  {
                    display: "Fecha creación",
                    value: "created_at"
                  },
                  {
                    display: "Modificador",
                    value: "modificador.nombre"
                  },
                  {
                    display: "Fecha modificación",
                    value: "updated_at"
                  }
                ]
              },
              on: { crear: _vm.crear, eliminar: _vm.eliminar }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "tipoMovimientoModal",
            scrollable: "",
            resizable: "",
            reset: "",
            adaptive: "",
            height: "auto",
            width: "60%"
          }
        },
        [
          _c("tipo-movimiento", {
            ref: "tipoMovimientoModal",
            on: { cancelar: _vm.cancelar, saved: _vm.savedTipoMovimiento },
            model: {
              value: _vm.selectedTipoMovimiento,
              callback: function($$v) {
                _vm.selectedTipoMovimiento = $$v
              },
              expression: "selectedTipoMovimiento"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Tipos de movimiento de nómina")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e9ce09", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24e9ce09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ListaTiposMovimiento.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-24e9ce09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ListaTiposMovimiento.vue
// module chunks = 0